import { GameAudio } from "../audio/GameAudio";
import { GameConfig, RouteName, visibleDesignHeight } from "../config/GameConfig";
import { GameNavigator } from "../core/Navigation";
import { UIFactory } from "./UIFactory";

type MainTab = "home" | "tasks" | "wallet" | "mine";

export class AppTabBar extends Laya.Box {
    constructor(nav: GameNavigator, active: MainTab) {
        super();
        this.name = "red_packet_tab_bar";
        this.width = GameConfig.DESIGN_WIDTH;
        this.height = 112;
        this.updatePosition();
        Laya.stage.on(Laya.Event.RESIZE, this, this.updatePosition);
        this.mouseEnabled = true;

        this.graphics.drawRect(0, 8, this.width, 104, "#5A1C17");
        this.graphics.drawRect(0, 0, this.width, 12, "#8C2C20");
        this.graphics.drawRect(0, 0, this.width, 4, "#FFD979");
        this.graphics.drawRect(0, 8, this.width, 2, "#E99A48");

        const tabs: Array<{ route: MainTab; icon: string; label: string }> = [
            { route: "home", icon: "⌂", label: "首页" },
            { route: "tasks", icon: "✓", label: "任务" },
            { route: "wallet", icon: "¥", label: "红包" },
            { route: "mine", icon: "人", label: "我的" },
        ];
        tabs.forEach((tab, index) => this.addTab(nav, active, tab.route, tab.icon, tab.label, index));
    }

    destroy(destroyChild = true): void {
        Laya.stage.off(Laya.Event.RESIZE, this, this.updatePosition);
        super.destroy(destroyChild);
    }

    private updatePosition(): void {
        this.pos(0, Math.max(0, visibleDesignHeight() - this.height));
    }

    private addTab(nav: GameNavigator, active: MainTab, route: MainTab, icon: string, text: string, index: number): void {
        const selected = active === route;
        const box = new Laya.Box();
        box.name = `tab_${route}`;
        box.width = 187.5;
        box.height = 112;
        box.pos(index * 187.5, 0);
        box.mouseEnabled = true;

        if (selected) {
            UIFactory.roundRect(box, 11, 16, 165.5, 88, 24, "#FFE6A5", "#F3B64B", 3);
            UIFactory.roundRect(box, 18, 22, 151.5, 72, 20, "#FFF3CA", "#FFFFFF88", 2);
        }

        const iconHolder = new Laya.Box();
        iconHolder.width = 64;
        iconHolder.height = 64;
        iconHolder.pivot(32, 32);
        iconHolder.pos(93.75, selected ? 21 : 35);
        iconHolder.graphics.drawCircle(32, 35, selected ? 31 : 25, selected ? "#7B251B" : "#8F382A", "#FFD979", selected ? 4 : 2);
        iconHolder.graphics.drawCircle(32, 31, selected ? 28 : 22, selected ? "#E94732" : "#A94935", selected ? "#FFF0A3" : "#C87950", 2);
        const iconLabel = UIFactory.label(icon, selected ? 32 : 27, "#FFF0B0", 64, 58, true);
        iconLabel.pos(0, 2);
        iconLabel.mouseEnabled = false;
        iconHolder.addChild(iconLabel);
        iconHolder.mouseEnabled = false;
        box.addChild(iconHolder);

        const label = UIFactory.label(text, selected ? 23 : 21, selected ? "#7B251B" : "#F5D49A", 120, 36, true);
        label.pos(33.75, selected ? 65 : 72);
        label.mouseEnabled = false;
        box.addChild(label);

        if (selected) {
            iconHolder.scale(0.76, 0.76);
            Laya.Tween.to(iconHolder, { scaleX: 1, scaleY: 1, y: 21 }, 240, Laya.Ease.backOut);
        }

        box.on(Laya.Event.CLICK, box, () => {
            if (selected) return;
            GameAudio.playSfx("click", 0);
            nav.navigate(route as RouteName);
        });
        this.addChild(box);
    }
}
